module.exports = __webpack_public_path__ + "img/input-plus.a8cd7ab0.svg";